export default __webpack_public_path__ + "static/media/ipams-1.d5940460.jpg";